import { useDispatch } from "react-redux";
import {
  useCreateLocationMutation,
  useUpdateLocationMutation,
} from "../../../Store/Builder/techsbook.api";
import { setLoader } from "../../../Store/Slice/techsbookSlice";
import showToast from "../../Hooks/toast";

const useUpdateLocationApi = () => {
  const dispatch = useDispatch();
  const [update] = useUpdateLocationMutation();

  const send = (body, setModal) => {
    dispatch(setLoader(true));
    update(body)
      .unwrap()
      .then((res) => {
        dispatch(setLoader(false));
        showToast(res?.message ?? "Success", "success");
        setModal();
      })
      .catch((err) => {
        dispatch(setLoader(false));
        showToast(err?.data?.message ?? "Error", "error");
      });
  };

  return {
    send,
  };
};

export default useUpdateLocationApi;
